import {
    BENEFIT_INFO_ONE,
    BENEFIT_INFO_TWO,
    BENEFIT_INFO_THREE,
    BENEFIT_INFO_FOUR,
    BENEFIT_INFO_FIVE,
    PRODUCT_INFO_ONE,
    PRODUCT_INFO_TWO,
    PRODUCT_INFO_THREE,
    ZERO,
    RATE,
    INFO_LIST_ONE,
    INFO_LIST_TWO,
    INFO_LIST_THREE,
    INFO_LIST_FOUR
} from './imageList';
// 活动组类型
export const GroupType = {
    A: 'group_a',
    B: 'group_b',
    C: 'group_c',
    D: 'group_d',
    E: 'group_e',
    F: 'group_f'
};

// 页面类型
export const PageType = {
    LANDING_PAGE: 'landing_page',
    LOGIN_PAGE: 'login_page'
};
export const triggerType = {
    PAGE_SHOW: 'page_show',
    STAY_TIME: 'stay_time',
    INPUT_DURATION: 'input_duration'
};
// 活动状态
export enum ERROR_MAP {
    HOME = 'HOME',
    NET_ERROR = 'NET_ERROR',
    NET_TIMEOUT = 'NET_TIMEOUT',
    CAMPAIGN_OVER = 'CAMPAIGN_OVER'
}
// 信用卡协议
export const CREDIT_CARD_PROTOCOL =
    'https://privacycenter.didiglobal.com/directory/MX/101839';
// 权益列表
export const BENEFIT_INFO_LIST = [
    {
        title: 'Respaldada por Mastercard',
        description: 'Creada por DiDi y respaldada por Mastercard',
        icon: BENEFIT_INFO_ONE
    },
    {
        title: 'Sin anualidad',
        description: 'Sin anualidad de por vida, ni comisiones ocultas',
        icon: BENEFIT_INFO_TWO
    },
    {
        title: 'MSI',
        description:
            'Aprovecha los Meses Sin Intereses en comercios seleccionados',
        icon: BENEFIT_INFO_THREE
    },
    {
        title: 'Hasta 6% de CASHBACK*',
        description:
            'Recibe 6% de CASHBACK* en boletos de avión y de autobuses foráneos',
        icon: BENEFIT_INFO_FOUR
    },
    {
        title: 'Fácil aplicación',
        description:
            'La de crédito que solicitas 100% en línea desde tu celular, sin filas en solo 5 minutos.',
        icon: BENEFIT_INFO_FIVE
    }
];
// 产品列表
export const PRODUCT_INFO_LIST = [
    {
        title: 'Creada por DiDi y respaldada por Mastercard',
        icon: PRODUCT_INFO_ONE
    },
    {
        title: 'Sin anualidad de por vida ni comisiones ocultas. ',
        icon: PRODUCT_INFO_TWO
    },
    {
        title: 'La tarjeta de crédito que solicitas desde tu  celular, 100% en línea, sin filas y en solo 5 minutos',
        icon: PRODUCT_INFO_THREE
    }

];
// 促销列表
export const PROMOTION_LIST = [
    {
        title: 'MSI',
        description:
            'Aprovecha los Meses Sin Intereses en comercios seleccionados',
        image: ZERO
    },
    {
        title: 'Hasta 6% de CASHBACK*',
        description: 'La tarjeta de crédito con hasta 6% de CASHBACK* diario. ',
        image: RATE
    }
];

// 问题列表
export const QUESTION_LIST = [
    {
        title: '¿Cómo puedo solicitar la DiDi Card?',
        contentOne: '1. Descarga la app de DiDi Finanzas',
        contentTwo: '2. Llena la solicitud con tu INE vigente',
        contentThree: '3. Crea tu NIP'
    },
    {
        title: '¿Cómo puedo pagar viajes de DiDi, pedidos de DiDi Food o la tarjeta con CASHBACK*?',
        contentOne:
            '1. Entra al apartado de CASHBACK* desde tu aplicación de DiDi Finanzas',
        contentTwo:
            '2. Selecciona la opción que prefieras "Pago de mi DiDi Card" o "Transferir a mi Billetera"',
        contentThree: '3. Ingresa tu NIP'
    }
];

// 优惠列表
export const INFO_LIST = [
    {
        infoTitle: 'Sin anualidad de por vida',
        infoDescribe: 'Ni comisiones ocultas.',
        image: INFO_LIST_ONE
    },
    {
        infoTitle: 'Hasta 6% de CASHBACK* diario',
        infoDescribe: 'En boletos de avión, farmacias, cines y más. ',
        image: INFO_LIST_TWO
    },
    {
        infoTitle: 'Difiere tus compras',
        infoDescribe: 'Paga y difiere tus compras en hasta 12 meses.',
        image: INFO_LIST_THREE
    },
    {
        infoTitle: 'Atención al cliente',
        infoDescribe: 'Nuestro equipo de soporte está para ayudarte.',
        image: INFO_LIST_FOUR
    }
];
